module.exports = __webpack_public_path__ + "img/Ident-Process-8.1446733f.png";